module.exports = __webpack_public_path__ + "static/img/3-info-b2.2d5d45f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/3-info-b2.jpg
// module id = oukn
// module chunks = 0